
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.75 3.5h3.75V5H14v9.75a.75.75 0 01-.75.75H2.75a.75.75 0 01-.75-.75V5H.5V3.5h3.75V1.25A.75.75 0 015 .5h6a.75.75 0 01.75.75V3.5zM12.5 5h-9v9h9V5zM5.75 7.25h1.5v4.5h-1.5v-4.5zm3 0h1.5v4.5h-1.5v-4.5zM5.75 2v1.5h4.5V2h-4.5z","fill":"#7D1E36"}})])
          )
        }
      }
    